module.exports = __webpack_public_path__ + "img/classroom-guidelines_latest.ebee760d.png";